import { render, staticRenderFns } from "./ProductPriceRankingChart.vue?vue&type=template&id=83f52688&"
import script from "./ProductPriceRankingChart.vue?vue&type=script&lang=js&"
export * from "./ProductPriceRankingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports